import React from "react";
import "./App.css";

// eslint-disable-next-line
import { Carousel } from "../Carousel/Carousel";
import { Timer } from "./Timer.js";

import { ContactBox } from "../Contact/ContactBox.js";
import GLVid from "./Media/GLVid.mp4";
import GLPic from "./Media/GLPic.png";
import FadeIn from "react-fade-in";
import ApiError from "../Error/ApiError.js";
import LoadAnim from "./LoadAnim";

class App extends React.Component {
  constructor(props) {
    super(props);

    //State storage - should be hooked up with mongoose

    //We use OnLoadPost to get latest stored DB post. Intended to use with cancel button.
    this.state = {
      frontPage: null,
      title: "Velkommen til GAMERLAN",

      lanOver: false,
      lanGoing: false,

      response: "",
      error: false
    };

    //BINDINGS

    this.setLanOver = this.setLanOver.bind(this);
    this.setLanGoing = this.setLanGoing.bind(this);
    this.getFrontPage = this.getFrontPage.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.getFrontPage();
  }

  async getFrontPage() {
    try {
      fetch("/api/pagedata/getFrontPage", {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          pragma: "no-cache",
          "cache-control": "no-cache"
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          if (data && data.length > 0 && data[0]) {
            this.setState({ frontPage: data[0] });
            this.setState({ updated: Date().slice(16, 24) });
            this.setState({ error: false });
          } else {
            // Handle empty database case
            this.setState({
              frontPage: {
                post: "Welcome to pLANner Event Management System!",
                lanOver: false,
                lanGoing: false
              },
              updated: Date().slice(16, 24),
              error: false
            });
          }
        })
        .catch(err => {
          this.setState({ error: true });
          console.log(err);
        });
    } catch (err) {
      this.setState({ error: true });
      console.log(err);
    }
  }

  setLanOver() {
    this.setState({ lanOver: true });
  }

  setLanGoing() {
    this.setState({ lanGoing: true });
  }

  render() {
    return (
      <div>
        {this.state.error !== true && this.state.frontPage === null && (
          <LoadAnim />
        )}
        <FadeIn>
          {this.state.error && <ApiError />}
          {this.state.frontPage && this.state.frontPage !== null && (
            <div className="App">
              <Timer
                auth={this.state.auth}
                setLanOver={this.setLanOver}
                setLanGoing={this.setLanGoing}
                lanDate={this.state.frontPage.lanDate || ''}
                lanFinishedDate={this.state.frontPage.lanFinishedDate || ''}
                message={this.state.frontPage.postTitle || ''}
                timerOverMessage={this.state.frontPage.duringTitle || ''}
                timerOverSubMessage={this.state.frontPage.duringSubtitle || ''}
                lanOverMessage={this.state.frontPage.overTitle || ''}
                lanOverSubMessage={this.state.frontPage.overSubtitle || ''}
              />

              <div className="row">
                <div className="col-md-7 col-centered">
                  <div className="Post">
                    {this.state.lanOver === false &&
                      this.state.lanGoing === false &&
                      this.state.frontPage.useMoreInfoPost === false && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.frontPage.post
                          }}
                        />
                      )}
                    {this.state.lanOver === false &&
                      this.state.lanGoing === false &&
                      this.state.frontPage.useMoreInfoPost === true && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.frontPage.moreInfoPost
                          }}
                        />
                      )}

                    {this.state.lanOver === false &&
                      this.state.lanGoing === true && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.frontPage.duringPost
                          }}
                        />
                      )}
                    {this.state.lanOver === true &&
                      this.state.lanGoing === false && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.frontPage.overPost
                          }}
                        />
                      )}
                  </div>
                </div>
              </div>
              <div className="videoBack">
                <video
                  poster={GLPic}
                  id="myvideo"
                  className="htmlVideo"
                  playsInline
                  muted
                  autoPlay
                  loop
                >
                  <source src={GLVid} type="video/mp4" />
                  <Carousel auth={this.state.auth} />
                </video>
                <script> document.getElementById('myvideo').play(); </script>
              </div>

              {/*<Carousel auth={this.state.auth}/> */}

              <div className="ContactBoxWrapper">
                <ContactBox />
              </div>
            </div>
          )}
        </FadeIn>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js